export const colors = {
    white: '#fff',
    athensGray2: '#F8F9FA',
    athensGray: '#E8EBEE',
    solitude: '#EBF6FE',
    porcelain: '#EBEEF0',
    gallery: '#EDEDED',
    mercury: '#e5e5e5',
    iron: '#DEE0E3',
    iron2: '#CED0D4',
    platinum: '#E2E4E7',
    silver: '#CCCCCC',
    rollingStone: '#767D81',
    bombay: '#ADB0B3',
    shark: '#25282A',
    mandy: '#EE5E6C',
    seaBuckthorn: '#F69B26',
    portage: '#A097EE',
    mantis: '#69CC52',
    chathamsBlue: '#1A4471',
    pictonBlue: '#4BAEF8',
    dodgerBlue: '#3AAAFC',
    darkDodger: '#198be8',
    darkerDodger: '#1883db',
    cornflowerBlue: '#5AB1F0',
    capeCod: '#3B3E40',
    aquaHaze: '#F8FAFB',
    black: 'black',
    mutedGrey: '#99a0a4',
    backgroundBlue: '#EEF8FF',
    borderBlue: '#80C4F6',
    borderGray: '#DDE0E2',
    buttonBorderGray: '#E5E6E9',
    backgroundGray: '#F8F9FA',
    formErrorText: '#FF0000',
    mainText: '#303335',
    iconGray: '#A8A9AA',
    iconBlue: '#47B1FF',
    iconMagenta: '#BC00E1',
    iconOrange: '#F6A300',
    iconGreen: '#55D134',
    iconPink: '#E7577D',
    iconDarkRed: '#F50060',
    iconDarkGray: '#616569',
    halfTransparentBlack: 'rgba(0,0,0,0.55)',
    aTagBlue: '#3AAAFC',
    aTagHover: '#23527c',
    inactiveGray: '#DDE0E2',
    errorRed: '#FF0000',
    mutedBlue: '#f2f9fc',
}


// WEBPACK FOOTER //
// ./src/common/colors/app_colors.js